import { useTranslation } from 'next-i18next'
import React from 'react'
import { sprinkles } from 'ui/src/theme/sprinkles.css'
import type { StoryblokAsset } from '@/services/storyblok/storyblok'
import { getImgSrc } from '@/services/storyblok/Storyblok.helpers'
import { ImageWithPlaceholder } from '../ImageWithPlaceholder/ImageWithPlaceholder'
import { textLink } from '../TextLink/TextLink.css'
import { wrapper, image } from './DownloadableContentItem.css'

export type DownloadableContentProps = {
  url: string
  thumbnail: StoryblokAsset
}

export const DownloadableContentItem = ({ thumbnail, url }: DownloadableContentProps) => {
  const { t } = useTranslation('common')
  return (
    <div>
      <div className={wrapper}>
        <ImageWithPlaceholder src={getImgSrc(thumbnail.filename)} alt={thumbnail.alt} fill className={image} />
      </div>
      <div className={sprinkles({ margin: 'xs' })}>
        <a href={getImgSrc(url)} download={true} rel="nofollow noreferrer" className={textLink}>
          {t('DOWNLOAD_ASSET')}
        </a>
      </div>
    </div>
  )
}
